import React, { useCallback } from "react"
import SubButtonNav from "components/SubMenuNavButton"

const SubCategoryNavBar = ({ activeTab, setSelectedSubCategory, navBarList }) => {
  const handleButtonNav = useCallback((item) => {
    setSelectedSubCategory(item)
  }, [])

  return navBarList?.map((item) => (
    <SubButtonNav
      key={item?.id}
      style={{ marginRight: 12 }}
      onPress={() => handleButtonNav(item)}
      isActive={activeTab?.subcategory_name === item.subcategory_name ? true : false}>
      {item.subcategory_name}
    </SubButtonNav>
  ))
}

export default SubCategoryNavBar
